// import CancelIcon from "@mui/icons-material/Cancel";
// import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { Box, Button, Drawer, MenuItem, TextField } from "@mui/material";
import React, {useState } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { PdfService, SaveTemplate } from "../../adapter/PdfService";
import CodeEditor from "../../components/CodeEditor";
import GoBack from "../../components/GoBack";
export default function AddTemplate() {
  const [open, setOpen] = React.useState(false);
  const [src, setsrc] = React.useState("");
  const [html, setHtml] = React.useState("");
  const [templateName, setTemplateName] = useState("");
  // const [sampleFile, setSampleFile] = useState(null);
  // const [fileName, setFileName] = useState("");
  // const [fileChosen, setFileChosen] = useState(false);
  const navigate = useNavigate();
  const [request, setrequest] = useState({});
  const getHtml = (html) => {
    setHtml(html);
  };
  const [doctype, setdoctype] = React.useState("");

  const handleChange = (event) => {
    setdoctype(event.target.value);
  };
  const previewPDf = () => {
    PdfService({ html: html })
      .then((response) => {
        if (response.status === 200) {
          setOpen(true);
          const byteCharacters = atob(response.data.data);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: "application/pdf" });
          const url = URL.createObjectURL(blob);
          setsrc(url);
        }
      })
      .catch((e) => {
        // ShowNotification(e?.response?.data?.errors[0], "danger")
      });
  };
  let documentType = ["SOC", "IO", "AWARD", "IA", "OTHER_DIRECTION"];
  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  // async function convertFileToBase64(file) {
  //   return new Promise((resolve, reject) => {
  //     const reader = new FileReader();
  //     reader.readAsDataURL(file);
  //     reader.onload = () => {
  //       const base64String = reader.result.split(',')[1];
  //       resolve(base64String);
  //     };
  //     reader.onerror = reject;
  //   });
  // }
  
  const saveTemplate = async () => {
    try {
      // let base64File = null;
  
      // if (sampleFile) {
      //   base64File = await convertFileToBase64(sampleFile);
      // }
        if(!templateName || !doctype || !html){
             toast.error("All fields are mandatory!")
              return
        }
     const response = await SaveTemplate({
        ...request,
        templateName: templateName,
        template: html,
        documentType: doctype,
        // sampleCsv: base64File, 
      });
  
      if (response.data.status === "SUCCESS") {
        toast.success("Save Successfully");
        navigate("/app/template");
      } else {
        toast.error(response.data.message);
      }
    } catch (e) {
      toast.error(e.response?.data?.error || "Error saving template");
    }
  };

  // const fileInputRef = useRef(null);

  // const handleFileClick = () => {
  //   fileInputRef.current.click();
  // };

  // const handleFileChange = (e) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     setSampleFile(file);
  //     setFileName(file.name);
  //     setFileChosen(true);
  //   }
  // };

  // const handleClearFile = () => {
  //   setSampleFile(null);
  //   setFileName("");
  //   setFileChosen(false);
  //   if (fileInputRef.current) {
  //     fileInputRef.current.value = null;
  //   }
  // };

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <h2 style={{ color: "#333", fontWeight: "400" }}>ADD TEMPLATE</h2>
        <GoBack />
      </div>
      <ToastContainer />
      <div
        style={{display:"grid",gridTemplateColumns:"auto auto",gap:"1.5em",padding:"1em 0"}}
      >
        <TextField
          type="text"
          required={true}
          label="Enter Template Name"
          value={templateName}
          onChange={(e) => setTemplateName(e.target.value)}
          style={{ flex: 1 }}
        />
        <TextField
          select
          id="demo-simple-select"
          required={true}
          value={doctype}
          defaultValue=""
          placeholder="Select Document Type"
          label="Select Document Type"
          onChange={handleChange}
          style={{ flex: 1 }}
        >
          {documentType.map((option, index) => (
            <MenuItem key={index} value={option}>
              {option}
            </MenuItem>
          ))}
        </TextField>
        {/* <div
          onClick={handleFileClick}
          style={{
            flex: 1,
            padding: "1em",
            border: "2px dashed rgb(0 81 134 / 81%)",
            borderRadius: "5px",
            cursor: fileChosen ? "not-allowed" : "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            backgroundColor: fileChosen ? "#f5f5f5" : "white",
          }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <CloudUploadIcon
              style={{
                marginRight: "20px",
                color: fileChosen ? "#ccc" : "rgb(0 81 134 / 81%)",
              }}
            />
            <span style={{ color: "gray" }}>
              {fileName || "Upload Sample CSV"}
            </span>
          </div>
          {fileChosen && (
            <CancelIcon
              onClick={handleClearFile}
              style={{ color: "rgb(0 81 134 / 81%)", cursor: "pointer" }}
            />
          )}
          <input
            type="file"
            style={{ display: "none" }}
            onChange={handleFileChange}
            ref={fileInputRef}
            required
          />
        </div> */}
      </div>
      <CodeEditor getHtml={getHtml} />
      <Button
        variant="contained"
        sx={{ mt: 2, mb: 2 }}
        style={{
          background: "linear-gradient(118deg, #005186, rgb(0 81 134 / 81%))",
        }}
        onClick={previewPDf}
      >
        Preview
      </Button>
      <Button
        variant="contained"
        sx={{ mt: 2, mb: 2 }}
        style={{
          background: "linear-gradient(118deg, #005186, rgb(0 81 134 / 81%))",
          marginLeft: "1em",
        }}
        onClick={saveTemplate}
      >
        Save
      </Button>
      <Drawer
        open={open}
        sx={{ zIndex: "1203" }}
        anchor="right"
        onClose={toggleDrawer(false)}
      >
        <Box sx={{ width: "50vw", color: "#000" }}>
          <iframe style={{ width: "100%", height: "100vh" }} src={src} />
        </Box>
      </Drawer>
    </>
  );
}
